import PropTypes from 'prop-types';
import { useSiteContext } from '@eti/providers';
import { BoundNew } from '@eti/types';
import { date } from '@eti/utils';
import { useMediaQuery } from 'usehooks-ts';

const RentalCarsWidget = ({ bounds, obfuscatedOrderNumber }) => {
  const {
    language: { code: locale },
    siteCurrency: { code: currency },
  } = useSiteContext();
  const isNarrowScreen = useMediaQuery(`(max-width: 500px`);

  const outbound = bounds[0];
  const airportArrival = outbound.segments[outbound.segments.length - 1].destination.code;
  const start = outbound.segments[outbound.segments.length - 1].arrivedAt;
  const startDateDay = date.format(start, 'd');
  const startDateMonth = date.format(start, 'M');
  const startDateYear = date.format(start, 'yyyy');
  const startDateHour = date.format(start, 'H');
  const startDateMinute = date.format(start, 'm');
  const end = bounds[bounds.length - 1].segments[0].departuredAt;
  const endDateDay = date.format(end, 'd');
  const endDateMonth = date.format(end, 'M');
  const endDateYear = date.format(end, 'yyyy');
  const endDateHour = date.format(end, 'H');
  const endDateMinute = date.format(end, 'm');

  const params = {
    affiliateCode: 'gotogate2',
    preflang: locale,
    prefcurrency: currency,
    pickupIATACode: airportArrival,
    pickupDate: startDateDay,
    pickupMonth: startDateMonth,
    pickupYear: startDateYear,
    returnDate: endDateDay,
    returnMonth: endDateMonth,
    returnYear: endDateYear,
    results: 2,
    pickupHour: startDateHour,
    pickupMinute: startDateMinute,
    returnHour: endDateHour,
    returnMinute: endDateMinute,
    adco: obfuscatedOrderNumber,
  };

  const queryString = Object.keys(params)
    .map((k) => `${k}=${params[k]}`)
    .join('&');

  return (
    <iframe
      className="no-print"
      data-testid="upsell-rental-cars-iframe"
      height={isNarrowScreen ? '290' : '430'}
      id="upsell-rental-cars-iframe"
      src={`https://secure.rentalcars.com/WidgetSearch.do?${queryString}`}
      title="rental cars"
      width="100%"
    />
  );
};

RentalCarsWidget.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  obfuscatedOrderNumber: PropTypes.string,
};

export default RentalCarsWidget;
